import { useFlagBasedOnJSONDomain } from '@components/Flag';

export const useCarrierV2Flag = (): boolean => {
  const useCarrierV2 = useFlagBasedOnJSONDomain(
    'ME-35786-feat-carrier-migration-v2'
  );
  return useCarrierV2;
};
